import { Component, input, OnInit, signal, ViewEncapsulation } from '@angular/core';

import { ApIconComponent } from '@ap/icon';

/**
 * @ngdoc component
 * @name ApKeywordExplanationComponent
 */
@Component({
    selector: 'ap-keyword-explanation',
    templateUrl: './keyword-explanation.component.html',
    styleUrls: ['./keyword-explanation.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIconComponent]
})
export class ApKeywordExplanationComponent implements OnInit {
    /**
     * Required - The term to show in the explanation
     */
    public readonly term = input.required<string>();

    protected readonly termLastWord = signal<string>(undefined);
    protected readonly termSentence = signal<string>(undefined);
    protected readonly showExplanation = signal<boolean>(false);

    public toggle(): void {
        this.showExplanation.set(!this.showExplanation());
    }

    public ngOnInit(): void {
        // Separate the term into the last word and rest of the sentence.
        // The open/close icon will be in a span with the last word, so they stay on the same line (visually).
        // The first part of the term will still be able to go multi-line.
        if (this.term) {
            const words = this.term().split(' ');
            this.termLastWord.set(words.splice(-1, 1)[0]);
            if (words.length > 0) {
                this.termSentence.set(words.join(' '));
            }
        }
    }
}
